
















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import ContentsPage from "@/components/ContentsPage.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    ContentsPage,
    
    Footer,
  },
})
export default class AudioVisual extends Vue {
  protected contentsAudioVisu = [
    {
      ContentsTitle: "LES FONDAMENTAUX DE L'AUDIOVISUEL",
      ContentsPath: "/Audiovisuel/Fondamentaux",
      ContentsImage: "/thumbnail3.png",
    },
    {
      ContentsTitle: "MONTAGE VIDEO",
      ContentsPath: "/Audiovisuel/Montage",
      ContentsImage: "/thumbnail4.png"
    }
  ];
  
}
